module.exports = __webpack_public_path__ + "img/barco.4f698299.gif";